export default {
  header: {
    title: 'Geweldig! Je krijgt het volgende gratis bij je bestelling:',
    subtitle: 'We passen de korting toe tijdens het afrekenen.',
  },
  footer: {
    buttons: {
      no_thanks: 'Nee, bedankt',
      add_to_basket: 'Aan winkelwagen toevoegen',
    },
  },
};
